// src/context/DataProvider.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import Papa from "papaparse";

const DataContext = createContext();

export function useData() {
   return useContext(DataContext);
}

export function DataProvider({ children }) {
   const [articles, setArticles] = useState([]);
   const [categories, setCategories] = useState([]);
   const [loading, setLoading] = useState(true);

   // URL новостей
   const SHEET_CSV_URL =
      "https://docs.google.com/spreadsheets/d/15QXeksP66-O66Rh6kC32urGwlkiWhpkkTnXx2btWVXo/export?format=csv&id=15QXeksP66-O66Rh6kC32urGwlkiWhpkkTnXx2btWVXo&gid=0";
   // URL таблицы категорий
   const NEWS_TYPE_SHEET_URL =
      "https://docs.google.com/spreadsheets/d/15QXeksP66-O66Rh6kC32urGwlkiWhpkkTnXx2btWVXo/export?format=csv&id=15QXeksP66-O66Rh6kC32urGwlkiWhpkkTnXx2btWVXo&gid=1642065697";

   useEffect(() => {
      // Загружаем обе таблицы параллельно
      Promise.all([fetch(SHEET_CSV_URL).then((res) => res.text()), fetch(NEWS_TYPE_SHEET_URL).then((res) => res.text())])
         .then(([newsCsv, categoriesCsv]) => {
            // Парсим CSV (первый файл - новости, второй - категории)
            const newsResult = Papa.parse(newsCsv, { header: true });
            const catResult = Papa.parse(categoriesCsv, { header: true });

            // Преобразуем данные в массив
            const rawArticles = newsResult.data; // [{ID, Title, CategoryID, ...}, ...]
            const rawCategories = catResult.data; // [{ID, Title}, ...]

            // Запишем categories в стейт (может пригодиться для селектов и т.д.)
            setCategories(rawCategories);

            // Создаём объект "ID -> Title" для быстрого поиска категории
            // Например: { "1": "Қоғам", "2": "Мәдениет", ... }
            const categoryMap = {};
            rawCategories.forEach((cat) => {
               // cat.ID и cat.Title
               categoryMap[cat.ID] = cat.Title;
            });

            // Проходим по всем статьям, ищем CategoryID -> подставляем Title
            const mergedArticles = rawArticles.map((article) => {
               const { CategoryID } = article; // строка, например "1"
               // Находим Title категории
               const catTitle = categoryMap[CategoryID] || "Без категории";
               // Возвращаем новую статью с полем Category
               return {
                  ...article,
                  Category: catTitle, // теперь вместо CategoryID есть поле Category c названием
               };
            });

            setArticles(mergedArticles);
            setLoading(false);
         })
         .catch((err) => {
            console.error("Ошибка при загрузке CSV:", err);
            setLoading(false);
         });
   }, []);

   // Теперь articles имеет поле Category
   // и отдельно есть массив categories
   const value = {
      articles,
      categories,
      loading,
   };

   return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}
